/* Casa Lizette — generic accordion (FAQ, specs). Shared across product FAQ and legal FAQ page. */
(function () {
  'use strict';

  function togglePanel(item, open) {
    var panel = item.querySelector('.accordion-item__panel');
    var inner = item.querySelector('.accordion-item__panel-inner');
    if (!panel || !inner) return;
    item.setAttribute('data-open', open ? 'true' : 'false');
    var trigger = item.querySelector('.accordion-item__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? inner.offsetHeight + 'px' : '0px';
  }

  function initAccordion(container) {
    var items = container.querySelectorAll('.accordion-item');
    var allowMultiple = container.hasAttribute('data-accordion-multiple');

    items.forEach(function (item) {
      var trigger = item.querySelector('.accordion-item__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) togglePanel(other, false);
          });
        }
        togglePanel(item, !isOpen);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-accordion]').forEach(initAccordion);
  });
})();
